import React, { useState } from "react";
import Dropdown from "../../dropdown/dropdown";
import { Court, Slot, SlotType, BookingOwner } from "../../../types";
import CourtItemMedium from "../../items/court/medium";
import { getClubSlotsRequest } from "../../../actions";

function countAvailableSlotsForTimestamp(slots: Slot[], timestamp: number): number {
	const filteredSlots = slots.filter(slot => {
		if (slot.slotType === SlotType.Available && slot.startDateTime >= timestamp) {
			return true;
		}

		if (
			slot.slotType === SlotType.Booked &&
			slot.startDateTime === timestamp &&
			(slot.slotContext.booking.owner === BookingOwner.Me ||
				slot.slotContext.booking.owner === BookingOwner.Player)
		) {
			return true;
		}

		return false;
	});

	return filteredSlots.length;
}

function filterCourts(selectedCourt: Court, courts: Court[], timestamp: number): Court[] {
	return courts.filter(court => {
		if (!selectedCourt) {
			return true;
		}

		const availableSlotsCount = countAvailableSlotsForTimestamp(court.slots, timestamp);

		return court.sport === selectedCourt.sport && availableSlotsCount > 0;
	});
}

const CourtSelect = ({
	clubId,
	courts,
	value,
	onSelect,
	timestamp,
	loadingText,
}: {
	clubId: string;
	courts: Court[];
	value: string;
	onSelect: (court: Court) => void;
	timestamp: number;
	loadingText: string;
}) => {
	const selectedCourt = courts.find(court => {
		return court.courtId === value;
	});

	const [loading, setLoading] = useState(false);
	const [filteredCourts, setFilteredCourts] = useState([]);

	let dropdownValue = null;
	if (selectedCourt) {
		dropdownValue = <CourtItemMedium court={selectedCourt} />;
	}

	const onOpen = async () => {
		setLoading(true);
		const res = await getClubSlotsRequest(clubId, { day: timestamp });

		const courts = res.courts;

		setFilteredCourts(filterCourts(selectedCourt, courts, timestamp));

		setLoading(false);
	};

	return (
		<Dropdown
			value={dropdownValue}
			extraClass="courtDropdown"
			onItemSelect={onSelect}
			onOpen={onOpen}
			loading={loading}
			loadingText={loadingText}
		>
			{filteredCourts.map((court, index) => {
				return <CourtItemMedium court={court} key={index} value={court} />;
			})}
		</Dropdown>
	);
};

export default CourtSelect;
